<template>
  <ion-page>
  <master-layout pageTitle="فروش ضایعات">
    <ion-card-content>

      <ion-grid>
        <ion-row>
          <ion-col size="6">
            <MainPageItem :amount="oil+' لیتر'" icon="oil-can" itemTitle="حجم روغن سوخته" url="#"></MainPageItem>
          </ion-col>

          <ion-col size="6">
            <MainPageItem icon="dumpster-fire" itemTitle="سایر ضایعات" url="/wastage/List"></MainPageItem>
          </ion-col>

          <ion-col size="6">
            <MainPageItem icon="money-check-edit" itemTitle="درخواست فروش" url="/WastageSellRequest/Manage"></MainPageItem>
          </ion-col>

          <ion-col size="6">
            <MainPageItem icon="file-alt" itemTitle="ثبت فاکتور فروش" url="/WastageSellInvoice/list"></MainPageItem>
          </ion-col>

        </ion-row>
      </ion-grid>

    </ion-card-content>
  </master-layout>
  </ion-page>
</template>


<script>

import MainPageItem from '/src/components/MainPageItem'
import {
  IonCardContent, IonGrid, IonCol, IonRow,IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";

export default {
  components: {
    IonCardContent, IonGrid, IonCol, IonRow,IonPage , MainPageItem
  },
  data()
  {
    return {
      oil : '0',
    }
  },
  async mounted()
  {
    const check = await this.getOilAmount();
    if (check.ok)
      this.oil = check.oil;
  },
  methods: {
    ...mapActions("order", {
      getOilAmount: 'getOilAmount',
    }),
  }
};
</script>

<style scoped>

</style>